import _ from "lodash";
import { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useFetchTeamMember, useFetchTicketList } from "../redux/hooks";
import { get, isEmpty } from "lodash-es";
import TicketTable from "../components/TicketTable";

import {
  Button,
  SIZE,
  VARIANT,
} from "@metacrm/metacrm-material-ui/dist/Button";
import { InputField } from "@metacrm/metacrm-material-ui/dist/InputField";
import { Menu } from "@metacrm/metacrm-material-ui/dist/Menu";
import PopperMenu from "@metacrm/metacrm-material-ui/dist/PopperMenu";
import axios from "axios";
import { useDebounceEffect } from "components/ConnectWallet/ConnectWallet";
import { enqueueSnackbar } from "features/common/redux/actions";
import { apiUrl } from "features/configure";
import { parseCustomDomainUrl } from "features/helpers/utils";
import { selectTicketTypeForDropdown } from "features/metadesk/redux/entityConfig/entityConfig.selector";
import { fetchTagsAsyncAction } from "features/metadesk/redux/macro/macro.action";
import { selectMacroTags } from "features/metadesk/redux/macro/macro.selector";
import { Box, Slide } from "@mui/material";

import { Link, Navigate, useOutletContext } from "react-router-dom";
import { useIntl } from "react-intl";

import { selectRemindBarShow } from "../redux/globalState/globalState.selector";
import useNavigateEntity from "hooks/useNavigateEntity";
import TicketDetail from "./TicketDetail";
import { useSearchParams } from "react-router-dom";
import { TICKET_FILTER_INITIAL_STATE } from "../redux/fetchTicketList";
import EmptyIconStatus from "components/EmptyState/EmptyIconStatus";

const TicketList = ({ ticketStatus }) => {
  const dispatch = useDispatch();
  const [entityName, isCustomDomain] = useOutletContext();
  const [loading, setLoading] = useState(false);
  const [channelOptions, setChannelOptions] = useState([]);
  const [channelData, setChannelData] = useState([]);
  const [getSourceLoading, setGetSourceLoading] = useState(false);
  const status = ticketStatus || "new";
  const { memberList } = useFetchTeamMember();
  let [searchParams, setSearchParams] = useSearchParams();
  const openTicketDetail = searchParams.get("ticketId");
  const {
    ticketList,
    fetchTicketList,
    ticketCounts,
    fetchTicketListPending,
    updateTicketListFilter,
    ticketListFilter,
  } = useFetchTicketList();

  const { formatMessage } = useIntl();
  const page = _.get(ticketListFilter, `page`, 1);
  const orderData = _.get(ticketListFilter, `orderData`);
  const remindBarShow = useSelector(selectRemindBarShow);
  const searchText = _.get(ticketListFilter, "searchText", "");
  const ticketTypeForDropdown = useSelector(selectTicketTypeForDropdown);
  const tagOptions = useSelector(selectMacroTags);

  const channelFilterNumber = useMemo(
    () =>
      isEmpty(ticketListFilter.channel) ? 0 : ticketListFilter.channel.length,
    [ticketListFilter.channel]
  );

  const searchTagsFilterNumber = useMemo(
    () =>
      isEmpty(ticketListFilter.searchTags)
        ? 0
        : ticketListFilter.searchTags.length,
    [ticketListFilter.searchTags]
  );

  const addressFilterNumber = useMemo(
    () => (ticketListFilter.addressStatus ? 1 : 0),
    [ticketListFilter.addressStatus]
  );

  const issueFilterNumber = useMemo(
    () => (isEmpty(ticketListFilter.issue) ? 0 : ticketListFilter.issue.length),
    [ticketListFilter.issue]
  );

  const assigneeFilterNumber = useMemo(
    () =>
      isEmpty(ticketListFilter.assigneeOrCollaborator)
        ? 0
        : ticketListFilter.assigneeOrCollaborator.length,
    [ticketListFilter.assigneeOrCollaborator]
  );

  const topFilterNumber = useMemo(
    () =>
      channelFilterNumber +
      searchTagsFilterNumber +
      addressFilterNumber +
      issueFilterNumber +
      assigneeFilterNumber,
    [
      channelFilterNumber,
      addressFilterNumber,
      issueFilterNumber,
      assigneeFilterNumber,
      searchTagsFilterNumber,
    ]
  );

  const handleChangeCheckbox = (e, filterKey) => {
    e.keepOpen = true;
    if (e.checked) {
      // 要是是選中
      if (e.value === "") {
        // 選全選的話(空字串) 就只要設定全選進入結果就好
        updateTicketListFilter({
          ...ticketListFilter,
          page: 1,
          [filterKey]: [],
        });
      } else {
        // 選全選以外的 就要把空字串過去料 並把舊的值 新的值都放進去
        const newFilter = ticketListFilter[filterKey].filter(
          (value) => value !== ""
        );

        updateTicketListFilter({
          ...ticketListFilter,
          page: 1,
          [filterKey]: [...newFilter, e.value],
        });
      }
    } else {
      // 要是是取消
      const newValue = ticketListFilter[filterKey].filter(
        (value) => value !== e.value
      );
      updateTicketListFilter({
        ...ticketListFilter,
        page: 1,
        [filterKey]: newValue,
      });
    }
  };

  const handleChangeRadioBtn = (e, filterKey) => {
    e.keepOpen = true;
    updateTicketListFilter({
      ...ticketListFilter,
      page: 1,
      [filterKey]: e.value,
    });
  };

  const handleGetSource = async () => {
    setGetSourceLoading(true);
    try {
      let { data } = await axios.get(
        `${apiUrl}/api/ticket/${entityName}/sources`
      );
      const transformName = ["supportCenter", "discord", "telegram"];
      const formatData = data.map((item) => ({
        label: transformName.includes(item.name)
          ? _.startCase(item.name)
          : item.name,
        value: item._id,
      }));

      setChannelOptions([
        { label: "All", isAllOption: true, value: "" },
        ...formatData,
      ]);
      setChannelData(formatData);
    } catch (error) {
      dispatch(
        enqueueSnackbar({
          message: get(error, "response.data.error", "error"),
          options: {
            variant: "error",
          },
        })
      );
    } finally {
      setGetSourceLoading(false);
    }
  };

  useEffect(() => {
    dispatch(fetchTagsAsyncAction({ entityName: entityName }));
    handleGetSource();
  }, []);

  useEffect(() => {
    if (_.get(ticketListFilter, "ticketStatus") === ticketStatus) return;
    if (page != 1) updateTicketListFilter({ page: 1, ticketStatus });
    else updateTicketListFilter({ ticketStatus });
  }, [ticketStatus]);

  useEffect(() => {
    setLoading(false);
  }, [ticketList]);

  useDebounceEffect(
    () => {
      fetchTicketList({
        entityName,
        filter: ticketListFilter,
      });
    },
    500,
    [ticketListFilter],
    () => setLoading(true)
  );

  const itemList = useMemo(
    () => [
      {
        children: <>{formatMessage({ id: "global.filter.channel" })}</>,
        filterNumber: channelFilterNumber,
        subMenu: [
          {
            children: <>{formatMessage({ id: "global.filter.all" })}</>,
            value: "",
            type: "checkbox",
            checked: isEmpty(ticketListFilter.channel),
            func: (e) => handleChangeCheckbox(e, "channel"),
          },
          ...channelData.map((item) => ({
            children: <>{item.label}</>,
            value: item.value,
            type: "checkbox",
            checked: ticketListFilter.channel.some(
              (channelValue) => channelValue === item.value
            ),
            func: (e) => handleChangeCheckbox(e, "channel"),
          })),
        ],
      },
      {
        children: <>{formatMessage({ id: "global.filterCriteria.tags" })}</>,
        filterNumber: searchTagsFilterNumber,
        subMenu: [
          {
            children: <>{formatMessage({ id: "global.filter.all" })}</>,
            value: "",
            type: "checkbox",
            checked: isEmpty(ticketListFilter.searchTags),
            func: (e) => handleChangeCheckbox(e, "searchTags"),
          },
          ...tagOptions.map((item) => ({
            children: <>{item.value}</>,
            value: item._id,
            type: "checkbox",
            backgroundColor: item.color,
            checked: ticketListFilter.searchTags.some(
              (tagValue) => tagValue === item._id
            ),
            func: (e) => handleChangeCheckbox(e, "searchTags"),
          })),
        ],
      },
      {
        children: (
          <>{formatMessage({ id: "global.property.addressCollection" })}</>
        ),
        type: "radioGroup",
        value: ticketListFilter.addressStatus,
        onRadioChange: (e) => handleChangeRadioBtn(e, "addressStatus"),
        filterNumber: addressFilterNumber,
        subMenu: [
          {
            children: <>{formatMessage({ id: "global.filter.all" })}</>,
            value: "",
            type: "radio",
            checked: ticketListFilter.addressStatus === "",
          },
          {
            children: (
              <>{formatMessage({ id: "global.filterCriteria.hasAddress" })}</>
            ),
            value: "withAddress",
            type: "radio",
            checked: ticketListFilter.addressStatus === "withAddress",
          },
          {
            children: (
              <>{formatMessage({ id: "global.filterCriteria.noAddress" })}</>
            ),
            value: "withoutAddress",
            type: "radio",
            checked: ticketListFilter.addressStatus === "withoutAddress",
          },
        ],
      },
      {
        children: <>{formatMessage({ id: "global.function.issues" })}</>,
        filterNumber: issueFilterNumber,
        subMenu: [
          {
            children: <>{formatMessage({ id: "global.filter.all" })}</>,
            value: "",
            type: "checkbox",
            checked: isEmpty(ticketListFilter.issue),
            func: (e) => handleChangeCheckbox(e, "issue"),
          },
          ...ticketTypeForDropdown.map((item) => ({
            children: <>{item.label}</>,
            value: item.value,
            type: "checkbox",
            checked: ticketListFilter.issue.some(
              (issueValue) => issueValue === item.value
            ),
            func: (e) => handleChangeCheckbox(e, "issue"),
          })),
        ],
      },
      {
        children: <>{formatMessage({ id: "global.header.assignee" })}</>,
        filterNumber: assigneeFilterNumber,
        subMenu: [
          {
            children: <>{formatMessage({ id: "global.filter.all" })}</>,
            value: "",
            type: "checkbox",
            checked: isEmpty(ticketListFilter.assigneeOrCollaborator),
            func: (e) => handleChangeCheckbox(e, "assigneeOrCollaborator"),
          },
          ...memberList.map((item) => ({
            children: <>{item.name}</>,
            value: item._id,
            type: "checkbox",
            checked: ticketListFilter.assigneeOrCollaborator.some(
              (assigneeValue) => assigneeValue === item._id
            ),
            func: (e) => handleChangeCheckbox(e, "assigneeOrCollaborator"),
          })),
        ],
      },
    ],
    [
      addressFilterNumber,
      assigneeFilterNumber,
      channelData,
      channelFilterNumber,
      handleChangeCheckbox,
      handleChangeRadioBtn,
      issueFilterNumber,
      memberList,
      searchTagsFilterNumber,
      tagOptions,
      ticketListFilter.addressStatus,
      ticketListFilter.assigneeOrCollaborator,
      ticketListFilter.channel,
      ticketListFilter.issue,
      ticketListFilter.searchTags,
      ticketTypeForDropdown,
    ]
  );

  const { navigateEntity } = useNavigateEntity();
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const popperMenuList = [
    {
      children: <>{formatMessage({ id: "global.function.ticketSetting" })}</>,
      func: () => navigateEntity("/settings/service-module/ticket"),
    },
    {
      children: <>{formatMessage({ id: "globol.module.macros" })}</>,
      func: () => navigateEntity("/settings/service-module/macros"),
    },
    {
      children: <>{formatMessage({ id: "global.function.aiSupport" })}</>,
      func: () => navigateEntity("/settings/ai/tools"),
    },
    {
      children: (
        <>{formatMessage({ id: "global.function.dataSourceSetting" })}</>
      ),
      func: () => navigateEntity("/settings/service-module/onchain-data"),
    },
    {
      children: <>{formatMessage({ id: "securitySetting.security.title" })}</>,
      func: () => navigateEntity("/settings/service-module/security"),
    },
  ];
  const anchorRef = useRef(null);

  const renderFilter = () => {
    return (
      <Box
        sx={{
          paddingTop: "24px",
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "space-between",
        }}
      >
        <div className="startRow" style={{ flexWrap: "wrap" }}>
          <Box mr={1}>
            <InputField
              size={SIZE.MEDIUM}
              style={{ width: "360px" }}
              startAdornment={
                <i className="meta-crm-icon-ic_search font-size-14" />
              }
              placeholder={formatMessage({ id: "tickets.search.placeholder" })}
              value={searchText}
              onChange={(e) => {
                updateTicketListFilter({
                  page: 1,
                  searchText: e.target.value,
                });
              }}
            />
          </Box>

          {!getSourceLoading && (
            <>
              <Box mr={1}>
                <Menu
                  overflow="auto"
                  position="initial"
                  itemList={itemList}
                  topFilterNumber={topFilterNumber}
                  isFilter
                  filterText={formatMessage({ id: "global.filter.filter" })}
                />
              </Box>
              <Button
                variant={VARIANT.TEXT}
                style={{ padding: 0 }}
                size={SIZE.SMALL}
                onClick={() => {
                  updateTicketListFilter({
                    ...TICKET_FILTER_INITIAL_STATE.ticketListFilter,
                    ticketStatus: ticketListFilter.ticketStatus,
                  });
                }}
              >
                {formatMessage({ id: "global.filter.clean" })}
              </Button>
            </>
          )}
        </div>
        <Box fontSize={"12px"} fontWeight={400}>
          {ticketCounts} {formatMessage({ id: "global.unit.ticket" })}
        </Box>
      </Box>
    );
  };
  if (!ticketStatus)
    return (
      <Navigate
        to={parseCustomDomainUrl(
          isCustomDomain,
          entityName,
          "/service/ticket/new"
        )}
        replace
      />
    );

  return (
    <main>
      <Slide direction="left" in={openTicketDetail}>
        <Box
          position={"absolute"}
          display={openTicketDetail ? "block" : "none"}
          top="0px"
          bottom="0px"
          left="0px"
          right="0px"
          p="8px"
          zIndex={500}
          backgroundColor="#EEE"
        >
          {openTicketDetail && (
            <TicketDetail
              ticketId={openTicketDetail}
              onClose={() => setSearchParams({})}
            />
          )}
        </Box>
      </Slide>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div className="title fade-up" key={ticketStatus}>
          {formatMessage({ id: "tickets.header.title" })} -{" "}
          {formatMessage({ id: `global.ticketStatus.${status}` })}
        </div>
        <Button
          onClick={() => {
            setOpen(true);
          }}
          ref={anchorRef}
          sx={{ height: "36px", minWidth: "36px", padding: 0 }}
        >
          <i className="meta-crm-icon-ic_settingLine font-size-16" />
        </Button>

        <PopperMenu
          itemList={popperMenuList}
          placement="bottom-end"
          open={open}
          onClose={handleClose}
          anchorEl={anchorRef.current}
        />
      </Box>
      <Box key={ticketStatus} className="fade-up-more">
        {renderFilter()}
        <div style={{ marginTop: 8, position: "relative" }}>
          {ticketList && (
            <TicketTable
              setOpenTicketDetail={(ticketId) => {
                setSearchParams({ ticketId });
              }}
              orderData={orderData}
              noDataComponent={
                <EmptyIconStatus
                  icon="table"
                  wording="later"
                  emptyTitle={formatMessage({
                    id: "emptyState.table.title",
                  })}
                  emptyDescription={formatMessage({
                    id: "emptyState.table.description",
                  })}
                />
              }
              containerStyle={{
                maxHeight: `calc(100vh - ${remindBarShow ? 214 : 188}px)`,
              }}
              setOrderData={(v) => updateTicketListFilter({ orderData: v })}
              isCustomDomain={isCustomDomain}
              ticketList={ticketList}
              entityName={entityName}
              dataCounts={ticketCounts}
              page={page}
              setPage={(v) => updateTicketListFilter({ page: v })}
              loading={loading}
            />
          )}
        </div>
      </Box>
    </main>
  );
};

export default TicketList;
